import Championships from '@/apps/Championships'
import Layout from '@/apps/layout/components'
import React from 'react'

const ChampionshipsPage = (): React.ReactElement => {
  return (
    <Layout>
      <Championships />
    </Layout>
  )
}

export default ChampionshipsPage
